import React, { PureComponent } from 'react'
import { Alert, Container } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { LandingLayout } from './landing_layout'

export default class LoginPage extends PureComponent {
  handleClick = (e) => {
    // TODO: obsolete code
    // eslint-disable-next-line react/no-string-refs
    const username = this.refs.email && this.refs.email.value.trim()
    // TODO: obsolete code
    // eslint-disable-next-line react/no-string-refs
    const password = this.refs.password && this.refs.password.value.trim()
    // TODO: obsolete code
    // eslint-disable-next-line react/no-string-refs
    const code = this.refs.code && this.refs.code.value.trim()
    e.preventDefault()
    if (!username && !this.props.ephemeralToken) {
      window.alert('Please enter username')
      return
    }
    if (!password && !this.props.ephemeralToken) {
      window.alert('Please enter password')
      return
    }
    if (!code && this.props.ephemeralToken) {
      window.alert('Please enter code from an auth app')
      return
    }
    const creds = { username: username, password: password, code, ephemeral_token: this.props.ephemeralToken }
    this.props.onLoginClick(creds)
  }

  render() {
    const { errorMessage, isLogoutSuccess, ephemeralToken } = this.props
    return (
      <LandingLayout>
        <Container>
          <form style={{ width: 400 }}>
            <div>
              {!ephemeralToken && (
                <div>
                  <div style={styles.input}>
                    <input
                      // TODO: obsolete code
                      // eslint-disable-next-line react/no-string-refs
                      ref='email'
                      type='email'
                      className='form-control'
                      placeholder='Username'
                      required=''
                    />
                  </div>
                  <div style={styles.input}>
                    <input
                      // TODO: obsolete code
                      // eslint-disable-next-line react/no-string-refs
                      ref='password'
                      type='password'
                      className='form-control'
                      placeholder='Password'
                      required=''
                    />
                  </div>
                </div>
              )}
              {ephemeralToken && (
                <div>
                  <p>Two factor authentication is enabled</p>
                  <div style={styles.input}>
                    <input
                      // TODO: obsolete code
                      // eslint-disable-next-line react/no-string-refs
                      ref='code'
                      className='form-control'
                      placeholder='Code from an app'
                      required
                      autoFocus={true}
                    />
                  </div>
                </div>
              )}
            </div>

            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <button
                className='btn btn-round-sm'
                type='submit'
                onClick={(e) => this.handleClick(e)}
                style={styles.button}
              >
                Login
              </button>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Link to='/reset-password'>Forgot Password</Link>
            </div>
          </form>
          {errorMessage && (
            <div style={styles.error} className='alert alert-danger alert-dismissable'>
              {errorMessage}
            </div>
          )}
          {isLogoutSuccess && <Alert variant='info'>You have been successfully logged out</Alert>}
        </Container>
      </LandingLayout>
    )
  }
}

const styles = {
  input: {
    marginTop: 20,
    marginBottom: 20,
    marginLeft: 10,
    marginRight: 10,
  },
  button: {
    cursor: 'pointer',
    backgroundColor: '#43a5e9',
    color: '#fff',
    minWidth: '320px',
    borderRadius: '25px',
    marginBottom: '10px',
    height: '40px',
  },
  error: {
    marginLeft: 15,
    marginRight: 15,
  },
}
